import styled from 'styled-components';
import { breakpoint } from '@themes';

export const SectionContainer = styled.div<{ isArabic?: boolean }>`
  padding: 1rem 1rem;
  max-width: 100%;
  margin: 0 auto;
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};

  ${breakpoint('sm')`
    padding: 1rem;
  `}

  ${breakpoint('md')`
    padding: 2rem 3rem;
  `}

  ${breakpoint('lg')`
    padding: 2rem 4rem;
    max-width: 1200px;
  `}
`;

export const TitleContainer = styled.div<{ isArabic?: boolean }>`
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};
  padding: 0;
`;

export const ContentContainer = styled.div<{ isArabic?: boolean }>`
  direction: ${(props) => (props.isArabic ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};
`;

export const CountryTitle = styled.h2<{ isArabic?: boolean }>`
  padding: 0;
  font-family: 'Inter SemiBold';
  font-size: 24px;
  font-weight: 900;
  color: black;
  margin-bottom: 0.75rem;
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};

  ${breakpoint('md')`
    font-size: 28px;
  `}

  ${breakpoint('lg')`
    font-size: 32px;
    margin-bottom: 1rem;
  `}
`;

export const LastUpdateLabel = styled.p<{ isArabic?: boolean }>`
  font-family: 'Inter SemiBold';
  font-size: 18px;
  color: black;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};

  ${breakpoint('md')`
    font-size: 20px;
  `}

  ${breakpoint('lg')`
    font-size: 24px;
    margin-bottom: 2rem;
  `}
`;

export const LegalHeader = styled.h1<{ isArabic?: boolean }>`
  font-family: 'Inter SemiBold';
  font-size: 24px;
  color: black;
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};
  padding: 0;

  ${breakpoint('md')`
    font-size: 28px;
  `}

  ${breakpoint('lg')`
    font-size: 32px;
  `}
`;

export const LegalTitle = styled.h2<{ isArabic?: boolean }>`
  padding: 0;
  font-family: 'Inter SemiBold';
  font-size: 14px;
  font-weight: bold;
  color: black;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  text-align: ${(props) => (props.isArabic ? 'right' : 'left')};

  ${breakpoint('md')`
    font-size: 15px;
  `}

  ${breakpoint('lg')`
    font-size: 16px;
    margin-top: 2rem;
    margin-bottom: 1rem;
  `}
`;

export const StyledHr = styled.hr`
  width: 100%;
  margin: 1.5rem auto;
  border: none;
  border-top: 1px solid #000;

  ${breakpoint('lg')`
    margin: 2rem auto;
  `}
`;

export const KeypointsContainer = styled.div`
  border: 1px solid #000;
  padding: 0.75rem;
  margin-bottom: 1.5rem;

  ${breakpoint('md')`
    padding: 1rem;
  `}

  ${breakpoint('lg')`
    margin-bottom: 2rem;
  `}
`;
